export function hasText(value: unknown): boolean {
    if (typeof value !== 'string') {
        return false;
    }

    return value.trim() !== '';
}
